<template>
  <div class="pa-7" id="topics">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <v-row justify="center" align="center">
<v-col
      lg="7"
      xl="7">
              <v-img :src="src"></v-img>
              </v-col>
    </v-row>
    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
         <v-card-title class="descriptiontitle">
       <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1">
        mdi-arrange-bring-forward
        </v-icon>
              {{ item.descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
              </v-col>
              </div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: 'オンライン演題登録システム',
      // タイトル横のアイコン
      icon: 'mdi-laptop',
      // 画像
      src: require('../../assets/Products/registration1.jpg'),
      contents: [
        {
          descriptiontitle: 'システム',
          // 説明文
          description: `
本文に加えて、画像を添付することできます。またプレビューで確認することができます。`
        },
        {
          // 説明タイトル2
          descriptiontitle: '機能',
          icon: 'mdi-message-bulleted',
          // 説明文2
          description: `
・フォームへの直接入力又は、ファイルアップロード
・演者、共同演者登録
・期限設定`
        }
      ]
    }
  }
}
</script>
